import { NextSeo } from 'next-seo';
import React from 'react';

import Button from '/components/buttons/Button';
import Footer from '/components/Footer';
import Link from '/components/links/Link';
import FinalistPhotoGrid from '/components/photo-contest/FinalistPhotoGrid';
import documents from '/config/documents';

import Countdown from 'components/photo-contest/Countdown';

function PhotoFinalistsPage() {
    const dateCountdown = Date.parse('7 Aug 2023 23:59:59 GMT+2');
    const votingActive = new Date().getTime() < dateCountdown;

    return (
        <>
            <NextSeo
                title="Glasuj za najlepšo fotografijo Slovenije"
                description="Izmed več kot 4500 vaših fotografij smo izbrali 40 finalistov. Zdaj ste na vrsti vi, da glasujete in izberete zmagovalca, ki bo prejel Nikon Z 30. Izmed vseh, ki boste glasovali, bomo izžrebali dobitnike majic Kam za vikend."
                openGraph={{
                    description: 'Glasuj za najlepšo fotografijo in se poteguj za KZV majico.',
                    title: 'Glasuj za najlepšo fotografijo Slovenije',
                    images: [{ url: 'https://kamzavikend.si/images/foto-izbor/share_vote_new.png' }],
                    url: 'https://kamzavikend.si/foto-izbor/finalisti'
                }}
            />
            <div className="single-page nagradni-izbor-glasuj pt-6">
                <div className="container">
                    <section className="hero flex flex-col lg:flex-row justify-center lg:gap-16" id="hero">
                        <div>
                            <img
                                src="/images/foto-izbor/hero-photos.jpg"
                                alt="Fotografije Slovenije"
                                width="337"
                                height="493"
                                className="hidden lg:block"
                            />
                        </div>
                        <div className="flex items-center">
                            <div className="content max-w-lg">
                                <h1>Glasuj in osvoji KZV majico</h1>
                                <p className="pt-4">
                                    Glasuj za najlepše ali najbolj zanimive fotografije lepot Slovenije in prispevaj k
                                    izboru zmagovalca, ki bo prejel Nikon Z 30. Z glasovanjem se uvrstiš v žreb za eno
                                    od KZV majic.{' '}
                                </p>

                                <p className="my-2">
                                    <Button link="#photos" color="secondary" disabled={!votingActive}>
                                        {votingActive ? 'Glasuj zdaj' : 'Glasovanje je zaključeno'}
                                    </Button>
                                </p>
                                <div className="mt-2">
                                    <img
                                        src="/images/foto-izbor/glasuj-nagrade.png"
                                        alt="Kam za vikend foto izbor nagrade"
                                        width="703"
                                        height="276"
                                        className="max-h-96 w-auto"
                                    />
                                </div>

                                <p>
                                    <small>PARTNERJA</small>
                                </p>
                                <div className="flex items-center gap-3">
                                    <Link to="https://bigbang.si" target="_blank">
                                        <img
                                            src="/images/foto-izbor/bigbang-logo.svg"
                                            alt="Big bang Slovenija"
                                            className="inline-block h-8"
                                        />
                                    </Link>
                                    <Link to="https://www.nikon.si/sl_SI" target="_blank">
                                        <img
                                            src="/images/foto-izbor/logo-nikon.svg"
                                            alt="Nikon"
                                            className="inline-block h-8"
                                        />
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </section>
                    <section id="countdown" className="text-center mt-8">
                        <h2>Do konca glasovanja še</h2>
                        <div className="flex justify-center mt-4">
                            <Countdown date={dateCountdown} />
                        </div>
                    </section>

                    <section id="photos" className="py-16 lg:py-20">
                        <div className="flex gap-4 justify-center">
                            <img src="/images/icons/puscica-dol.svg" alt="" className="hidden md:block" />
                            <h2 className="uppercase text-brand">Finalisti foto izbora lepot slovenije</h2>
                            <img src="/images/icons/puscica-dol.svg" alt="" className="hidden md:block" />
                        </div>
                        <div className="mt-6 lg:mt-8">
                            <FinalistPhotoGrid />
                        </div>
                    </section>

                    <section id="pravila" className="py-16 lg:py-20 text-center">
                        <p>
                            <Link to={documents.photoContestRules} target="_blank" styles="font-bold">
                                Poglej pravila sodelovanja
                            </Link>
                        </p>
                    </section>
                </div>

                <Footer />
            </div>
        </>
    );
}

export default PhotoFinalistsPage;
